var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "108px",
    viewBox: "0 0 108 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-spinner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HD-MOCKS--\\uD83E\\uDD19\\uD83C\\uDFFC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02---Admin---3---Loading",
    transform: "translate(-810.000000, -482.000000)",
    fill: "#BDC3C7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-spinner",
    transform: "translate(864.000000, 536.000000) rotate(47.000000) translate(-864.000000, -536.000000) translate(826.000000, 498.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,0 C58.9868205,0 76,17.0131795 76,38 C76,58.9868205 58.9868205,76 38,76 C17.0131795,76 0,58.9868205 0,38 C0,17.0131795 17.0131795,0 38,0 Z M38,7.6 C21.2105436,7.6 7.6,21.2105436 7.6,38 C7.6,54.7894564 21.2105436,68.4 38,68.4 C54.7894564,68.4 68.4,54.7894564 68.4,38 C68.4,21.2105436 54.7894564,7.6 38,7.6 Z",
    id: "Oval",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38,
    cy: 17.1,
    r: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8010356,25.5826561 L41.8,34.2 L57,34.2 C59.098682,34.2 60.8,35.901318 60.8,38 C60.8,40.098682 59.098682,41.8 57,41.8 L41.8,41.799 L41.8,58.9 C41.8,60.998682 40.098682,62.7 38,62.7 C35.901318,62.7 34.2,60.998682 34.2,58.9 L34.2,41.799 L19,41.8 C16.901318,41.8 15.2,40.098682 15.2,38 C15.2,35.901318 16.901318,34.2 19,34.2 L34.2,34.2 L34.1999613,25.5832329 C35.3178288,26.2298932 36.6156929,26.6 38,26.6 C39.3847186,26.6 40.6829428,26.2296731 41.8010356,25.5826561 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinner);
export default __webpack_public_path__ + "static/media/icon_spinner.4ebc392992196e646dca983cefe6453c.svg";
export { ForwardRef as ReactComponent };